import basic from "../../../assets/icons/buildSpotlightBasic.svg";
import audio from "../../../assets/icons/buildSpotlightAudio.svg";
import video from "../../../assets/icons/buildSpotlightVideo.svg";
import email from "../../../assets/icons/buildSpotlightEmail.svg";

export default [
  {
    title: "Basic Spotlight",
    desc: "Uses a simple text headline and call-to-action button",
    type: "text",
    tier: "free",
    icon: basic,
  },
  {
    title: "Audio Spotlight",
    desc: "Build trust with a custom audio message",
    type: "audio",
    tier: "starter",
    icon: audio,
  },
  // {
  //   title: "Video Spotlight",
  //   desc: "Engage your audience with a built-in video player",
  //   type: "video",
  //   tier: "premium",
  //   icon: video,
  // },
  // {
  //   title: "Email Capture Spotlight",
  //   desc: "Engage your audience with an email capture",
  //   type: "email",
  //   tier: "pro",
  //   icon: email,
  // },
];
